export const translations = {
  'da-DK': {
    translation: {
      showToday: 'Vis i dag',
      outOfRange: 'Uden for rækkevidde',
      selectUpToDays: 'Vælg dato inden for {maxDays} dage',
      From: 'Fra',
      FromToDateRangeError: 'Til-dato må ikke ligge før fra-dato',
      to: 'Til',
      dateFrom: 'Dato fra',
      loadingError: 'Indlæsningsfejl',
      contactAdmin:
        'Opdater siden for at indlæse dataene. Kontakt administratoren, hvis problemet fortsætter.',
      searchFor: 'Søg efter',
      nodes: 'Noder',
      cancel: 'Annuller',
      back: 'Tilbage',
      saveAndContinue: 'Gem og fortsæt',
      yes: 'Ja',
      no: 'Nej',
      selectDateRange: 'Select the date range between {days} days',
      Today: 'I dag',
      Yesterday: 'I går',
      LastWeek: 'Last Week',
      ThisMonth: 'This Month',
      LastMonth: 'Last Month',
      Last3Months: 'Last 3 Months',
      Last6Months: 'Last 6 Months',
      YearToDate: 'Year To Date',
      LastYear: 'Last Year',
      datePickerErrorMsg: 'Please select the dates within {days} months range.',
      datePickerGreaterErrorMessage: 'From Date cannot be greater than To Date',
      Duration: 'Duration',
      To: 'To',
      apply: 'Apply'
    }
  }
};
